import { createApp } from 'vue'
import website from './const/website.js'
import { loadThirdPartyIcons } from './utils'
import print from 'vue3-print-nb'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import routers from './router/index'
import './styles/index.scss'
import App from './App.vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn'
import 'element-plus/dist/index.css'
import pinia from './stores/pinia'
import { vFocus } from './directives/focus'

const app = createApp(App)

app.use(pinia)
// 注册打印
app.use(print)

// 全局设置语言为中文
app.use(ElementPlus, {
  locale: zhCn
})

app.use(routers)

// 注册所有 Element Plus 图标
Object.entries(ElementPlusIconsVue).forEach(([key, component]) => {
  app.component(key, component)
})

// 动态加载阿里云字体库
website.iconfontUrl.forEach(ele => {
  loadThirdPartyIcons(ele)
})

app.directive('focus', vFocus)

app.mount('#app')
